module.exports = __webpack_public_path__ + "static/media/npg-logo.0ae78f32.png";